import { fetchJSON, PUT, POST, GET } from 'utils/http';
import { GET_CLIENT_TOKEN, PUT_PAYMENT_NONCE, POST_SUBSCRIPTION, POST_SUBSCRIPTION_CS,
    GET_PAYMENT_HISTORY } from 'constants/urls';

export function getClientToken(id) {
  let url = GET_CLIENT_TOKEN;
  if (id) {
    url = `${url}?customer_id=${id}`;
  }
  return fetchJSON(url);
}

export function submitPaymentNonce(body) {
  return fetchJSON(PUT_PAYMENT_NONCE, PUT, {}, body, {});
}

export function postSubscription(body) {
  return fetchJSON(POST_SUBSCRIPTION, POST, {}, body, {});
}

export function postSubscriptionCS(body) {
  return fetchJSON(POST_SUBSCRIPTION_CS, POST, {}, body, {});
}

export function getPayments(id) {
  return fetchJSON(GET_PAYMENT_HISTORY + id, GET, {}, {}, {});
}



// WEBPACK FOOTER //
// ./src/common/services/payment.service/service.js